export function toCognitoPhone(phone: string): string {
  if (!phone) {
    return '';
  }
  phone = phone.replace(/\(|\)|-|\s|\+/g, '');
  return `+${phone.length === 11 ? '' : '1'}${phone}`;
}
